
import { AppTour } from '../tour.model';

export const CAPPING_DAILY_LIMIT_SETUP_TOUR: AppTour = {

  tourId: 'capping-daily-limit-setup-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: true,
    classes: 'tooltip-guide'
  },
  steps: [
    {
      id:"daily-policy-grid-selection-tour",
      attachTo: { element: '.chk-ag-grid-guide', on: 'bottom-start' },
      cancelIcon: {enabled: false},
      title: 'tour_daily_limit_setup_title',
      text: 'tour_daily_limit_setup_text',
      parallel: true
     }
   ]
};


export const CAPPING_DAILY_LIMIT_DETAILS_CATEGORY_TOUR: AppTour = {

  tourId: 'capping-daily-limit-details-category-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false,
    classes: 'tooltip-guide'
  },
  steps: [
    {
      id:"btn-add-policy-category-tour",
      attachTo: { element: '#btn-add-policy-category-guide', on: 'bottom-start' },
      cancelIcon: {enabled: false},
      title: 'tour_daily_limit_category_title',
      text: 'tour_daily_limit_category_text',
      parallel: true
     }
   ]
};


export const CAPPING_DAILY_LIMIT_DETAILS_LIMIT_TOUR: AppTour = {

  tourId: 'capping-daily-limit-details-limit-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false,
    classes: 'tooltip-guide'
  },
  steps: [
    {
      id:"txt-add-policy-limit-tour",
      attachTo: { element: '#txt-add-policy-limit-guide', on: 'bottom-start' },
      cancelIcon: {enabled: false},
      title: 'tour_daily_limit_add_title',
      text: 'tour_daily_limit_add_text',
      parallel: true
     }
   ]
};
